/* Submit form directly on changing one of the input fields */
$(document).on('change', "form [data-auto-submit='true'], form[data-auto-submit='true']", function(event) {
  // Submit this form using TurboStreams
  event.target.form.requestSubmit();
})